import React from 'react';

interface SectionProps {
  title: string;
  children: React.ReactNode;
}

const Section: React.FC<SectionProps> = ({ title, children }) => (
  <div className="mb-8">
    <h3 className="text-lg font-semibold mb-4" style={{ color: '#002457' }}>
      {title}
    </h3>
    {children}
  </div>
);

export default Section;
